export interface StudyModule {
  number: string
  title: string
  intro: string
  listLabel: string
  items: string[]
}

export const modules: StudyModule[] = [
  {
    number: 'MODULE I',
    title: 'The Prosthodontics Master Map',
    intro: 'See how the major areas of Prosthodontics fit together in one visual framework.',
    listLabel: "You'll get:",
    items: [
      'Master overview',
      'Major knowledge areas',
      'Concept relationships',
      'Recommended study sequence',
      'How to use the system',
    ],
  },
  {
    number: 'MODULE II',
    title: 'The Foundations You Need First',
    intro: 'Organize the core concepts that make everything else easier to understand.',
    listLabel: 'Includes:',
    items: [
      'Essential terminology',
      'Core concepts',
      'Components',
      'Functions',
      'Concept relationships',
      'Common mistakes',
    ],
  },
  {
    number: 'MODULE III',
    title: 'Classifications Without the Confusion',
    intro: 'Make difficult classifications easier to compare and review.',
    listLabel: 'Includes:',
    items: [
      'Major classifications',
      'Visual comparisons',
      'Key differences',
      'When each classification matters',
      'Common mistakes',
      'Quick-reference tables',
    ],
  },
  {
    number: 'MODULE IV',
    title: 'Materials & Selection',
    intro: 'Understand Prosthodontic materials through easy-to-scan comparison frameworks.',
    listLabel: 'Includes:',
    items: [
      'Material types',
      'Key characteristics',
      'Indications',
      'Advantages and limitations',
      'Side-by-side comparisons',
      'Selection considerations',
      'Common mistakes',
    ],
  },
  {
    number: 'MODULE V',
    title: 'Impressions & Records',
    intro: 'Visualize the major concepts, sequences, and relationships involved in impressions and records.',
    listLabel: 'Includes:',
    items: [
      'Clinical sequences',
      'Materials',
      'Techniques',
      'Components',
      'Critical steps',
      'Common problems',
      'Troubleshooting concepts',
    ],
  },
  {
    number: 'MODULE VI',
    title: 'Bases, Trays & Components',
    intro: 'Build a clear mental framework for the components you need to identify, compare, and review.',
    listLabel: 'Includes:',
    items: [
      'Types',
      'Characteristics',
      'Functions',
      'Differences',
      'Selection',
      'Adaptation',
      'Common mistakes',
    ],
  },
  {
    number: 'MODULE VII',
    title: 'Clinical Decision Maps™',
    intro: 'Turn isolated facts into visual decision pathways instead of memorizing disconnected lists.',
    listLabel: 'The pathway:',
    items: [
      'Situation',
      'Options',
      'Key difference',
      'Decision',
      'Next step',
      'Visual frameworks to reason through common situations',
    ],
  },
  {
    number: 'MODULE VIII',
    title: 'Error Control™',
    intro: 'A visual library of the concepts students most often confuse — "Don\'t mix these up…"',
    listLabel: 'Includes:',
    items: [
      'Concept A vs. Concept B',
      'Material A vs. Material B',
      'Technique A vs. Technique B',
      'Indication A vs. Indication B',
      'Step A vs. Step B',
      'Identify exactly what you are confusing',
    ],
  },
  {
    number: 'MODULE IX',
    title: 'Rapid Review™',
    intro: 'Review Prosthodontics based on the amount of time you actually have.',
    listLabel: 'Includes:',
    items: [
      '60 seconds → essential review cards',
      '5 minutes → key visual maps',
      '15 minutes → complete rapid-review session',
      '30 minutes → maps + comparisons + active recall',
    ],
  },
  {
    number: 'MODULE X',
    title: 'Exam Mode™',
    intro: 'Structure your final review before an exam.',
    listLabel: 'Includes:',
    items: [
      'Pre-exam checklist',
      'Self-assessment',
      'Weak-concept tracker',
      'Active-recall questions',
      'Mistake log',
      'Final review system + Master Map',
    ],
  },
]
